import React from "react";
import { useTranslation } from "../hooks/useTranslation";

interface OAuthButtonsProps {
  mode: "login" | "signup";
}

const OAuthButtons: React.FC<OAuthButtonsProps> = ({ mode }) => {
  const { t, currentLanguage } = useTranslation();

  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";

  const handleGoogleAuth = () => {
    const url = `${apiUrl}/auth/google?lang=${encodeURIComponent(
      currentLanguage
    )}`;
    window.location.href = url;
  };

  const googleLabel =
    mode === "login"
      ? t("auth.login.continueWithGoogle")
      : t("auth.signupOAuth.continueWithGoogle");

  return (
    <div className="space-y-5">
      <button
        type="button"
        onClick={handleGoogleAuth}
        className="flex w-full items-center justify-center gap-3 rounded-full border border-ink/25 bg-transparent px-5 py-3.5 text-sm font-medium text-ink transition-colors hover:border-ink hover:bg-ink hover:text-bone"
      >
        <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden>
          <path
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          />
          <path
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          />
        </svg>
        {googleLabel}
      </button>

      <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.22em] text-ink/40">
        <span className="h-px flex-1 bg-ink/15" />
        {t("auth.common.or")}
        <span className="h-px flex-1 bg-ink/15" />
      </div>
    </div>
  );
};

export default OAuthButtons;
